import React from "react";
import PropTypes from "prop-types";
import { categoryProps } from "layout/dictionary/edit/types";
import TextCell from "@visiblethread/react-components/dist/components/Table/cells/TextCell";

const CategoryName = ({
  category,
  category: { name, terms, error = "" },
  isSelected,
  disabled,
  isEditMode,
  onEditorClose,
  handleCellChange,
}) => {
  const handleNameChange = (newTextCell) => {
    handleCellChange(
      <CategoryName
        category={{ ...category, name: newTextCell.props.text }}
        isSelected={isSelected}
        isEditMode={isEditMode}
        disabled={disabled}
        onEditorClose={onEditorClose}
      />
    );
  };

  return (
    <div className="category_name" data-testid="category-name">
      <TextCell
        text={name}
        handleCellChange={handleNameChange}
        isSelected={isSelected}
        disabled={disabled}
        viewOnly={!isEditMode}
        error={error}
        editOnSelect={category.newlyCreated}
        onEditorClose={category.newlyCreated ? onEditorClose : undefined}
        placeholder="Enter Category Name"
      />
      <span className="category_name__amount_of_terms">{` (${terms.length})`}</span>
    </div>
  );
};

export default CategoryName;

CategoryName.propTypes = {
  isSelected: PropTypes.bool,
  category: PropTypes.shape(categoryProps),
  disabled: PropTypes.bool,
  isEditMode: PropTypes.bool,
  onEditorClose: PropTypes.func,
  handleCellChange: PropTypes.func,
};
